<template>
  <div
    v-if="!!block.data.text"
    class="w-mb"
    :class="{
      wrapper: block.tunes.headerTune !== 'gray-descriptor',
      'entry-body-wide w-mb2': block.tunes.headerTune == 'gray-descriptor',
    }"
  >
    <div
      :class="{
        wrapper: block.tunes.headerTune == 'gray-descriptor',
        'tac green': block.tunes.headerTune == 'green-descriptor',
      }"
    >
      <div :class="'h' + block.data.level" v-html="block.data.text"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HeaderBlock",
  props: ["block"],
};
</script>
<style lang="scss" scoped>
@import "resources/sass/block-headings.scss";

.entry-body-wide {
  @for $i from 1 through 6 {
    h#{$i},
    .h#{$i} {
      color: #000000;
      margin-bottom: 0;
    }
  }
}
.green {
  @for $i from 1 through 6 {
    h#{$i} {
      color: #c2e900;
    }
  }
}
</style>
